import React from "react";
import "./Cards.css";
import { Link } from "react-router-dom";
import CardItem from "./CardItem";

function DesignItems() {
  return (
    <>
    <div className="cards__container">
      <div className="cards__wrapper">
          <Link to="https://devpost.com/software/pawsible">
            <CardItem
              src={require("./images/pawsible.jpg")}
              text="Pawsible"
              label="WiCHacks10 (February 2024)"
              path="https://devpost.com/software/pawsible"
            />
          </Link>
        <Link to="https://devpost.com/software/hoppy-hands">
          <CardItem
            src={require("./images/hoppy.jpg")}
            text="Hoppy Hands"
            label="WiCHacks9 (February 2023)"
            path="https://devpost.com/software/hoppy-hands"
          />
        </Link>
        <Link to="https://devpost.com/software/brick-city-showdown">
          <CardItem
            src={require("./images/brick.jpg")}
            text="Brick City Showdown"
            label="BrickHacks8 (March 2022)"
            path="https://devpost.com/software/brick-city-showdown"
          />
        </Link>
        <Link to="https://devpost.com/software/shapeit">
          <CardItem
            src={require("./images/shapeIt.jpg")}
            text="ShapeIt!"
            label="BrickHacks9 (February 2023)"
            path="https://devpost.com/software/shapeit"
          />
        </Link>
        <Link to="https://drive.google.com/drive/folders/14s_woeSF2EC6cXOBj48mQwF6uSP2MZ_0?usp=sharing">
          <CardItem
            src={require("./images/characters.png")}
            text="Character Designs/Artworks"
            label="Hobby"
            path="https://drive.google.com/drive/folders/14s_woeSF2EC6cXOBj48mQwF6uSP2MZ_0?usp=sharing"
          />
        </Link>
      </div>
    </div>
  </>
  );
}

export default DesignItems;
